import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import network from "./utils/network";
import pinia from "@/store/pinia";
import { useAuthSessionStore } from "@/store/pinia/useAuthSessionStore";
import PageLoading from "./components/module/loading/PageLoading";
import { EVENTS } from "./utils/eventBus";
import PortalOther from "@/views/Other.vue";
import { changeTheme, getCurrentTheme, localFetch, tenantIdFromPath } from "@/utils/util";
import { UI_THEMES as _UI_THEMES } from "@/utils/const";
import { loadLanguageAsync } from "@/plugins/i18n";
import PortalError from "@/views/Error.vue";
import { defineAsyncComponent } from "vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Toast from "primevue/toast";
export default {
  name: "PortalHome",
  methods: {
    getCurrentTheme: getCurrentTheme
  },
  components: {
    AppLayout: AppLayout,
    PortalError: PortalError,
    PortalOther: PortalOther,
    PageLoading: PageLoading,
    Toast: Toast,
    LoadingIndicator: defineAsyncComponent(function () {
      return import("@/components/module/loading/LoadingIndicator");
    })
  },
  computed: {
    tenantIdFromPath: tenantIdFromPath,
    UI_THEMES: function UI_THEMES() {
      return _UI_THEMES;
    },
    isLoginLayout: function isLoginLayout() {
      return this.$route.meta ? this.$route.meta.loginLayout : false;
    },
    showSidebar: function showSidebar() {
      return !this.$route.meta || !this.$route.meta.hideSidebar;
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var axios, storedLocale;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.tenantId = _this.tenantIdFromPath;
            network.configure(_this.$store, _this.$router, _this.$toast);
            axios = network.createAxiosInstance();
            _this.$store.commit("uiConfigStore/setCurrentTheme", localFetch("current_ui_theme"));
            changeTheme(localFetch("current_ui_theme"));

            // eventBus.$on(EVENTS.PAGE_LOADING, () => (this.pageLoaded = false));
            // eventBus.$on(EVENTS.PAGE_LOADED, () => (this.pageLoaded = true));
            _context.n = 1;
            return _this.$store.dispatch("env/fetch");
          case 1:
            _context.n = 2;
            return useAuthSessionStore(pinia).bootstrap();
          case 2:
            storedLocale = localFetch("stored_locale");
            if (!storedLocale) {
              _context.n = 4;
              break;
            }
            _context.n = 3;
            return loadLanguageAsync(storedLocale);
          case 3:
            _context.n = 5;
            break;
          case 4:
            _context.n = 5;
            return loadLanguageAsync("hu");
          case 5:
            if (_this.tenantId) {
              _this.validTenant = true;
              document.querySelector('link[rel="icon"]').setAttribute("href", process.env.VUE_APP_FAVICON);
              _this.tenantExamined = true;
            } else {
              _this.tenantExamined = true;
            }
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      EVENTS: EVENTS,
      pageLoaded: true,
      tenantId: null,
      tenantExamined: false,
      validTenant: false,
      onboardingPage: false
    };
  }
};